import React, { ReactElement } from 'react';
import clsx from 'clsx';
import Image from 'next/image';
import { Button } from '@appsumo/dorado-react';

import { Loader } from '~/components/ui';
import CheckGreen from '~/public/font-awesome/check-dollar.png';

interface ApplyCartButtonProps {
  isApplied: boolean;
  isDisabled?: boolean;
  isLoading: boolean;
  onClick: (applyState: boolean) => void;
}

export default React.memo(function Credits({
  isApplied,
  isDisabled,
  isLoading,
  onClick,
}: Readonly<ApplyCartButtonProps>): ReactElement {
  const buttonTextClassname = clsx(
    'md:mx-auto',
    isApplied && 'text-dollar-dark-20',
  );

  return (
    <Button
      data-testid="apply-btn"
      secondary
      disabled={isApplied || isLoading || isDisabled}
      onClick={() => onClick(true)}
      className="mt-2 flex items-center justify-center md:mt-0"
    >
      {isApplied && (
        <Image
          src={CheckGreen}
          alt="check"
          width={16}
          className="mr-2 inline-block"
        />
      )}
      <span className={buttonTextClassname}>
        {isApplied ? 'Applied' : 'Apply'} to cart
      </span>
      {isLoading && !isApplied && <Loader className="ml-2" size="sm" />}
    </Button>
  );
});
